<template>
  <div>
    <CRow v-if="!loading">
      <CCol lg="12">
        <h1 class="main-header" v-translate translate-context="base_plan">
          Base Plan List
        </h1>
        <CCard class="">
          <CCardHeader>
            <div class="card-header-actions">
              <router-link :to="{name: 'base_plan.new', params: {region: regionId, category: categoryId}}"
                           v-if="hasPerm('admin.base_plan.create')">
                <CButton block color="primary" size="sm" v-translate translate-context="list.actions">Create</CButton>
              </router-link>
            </div>
          </CCardHeader>
          <CCardBody class="px-0">
            <AjaxTable
                :fields="fields"
                :data="basePlans"
                :fetch="fetchBasePlanList"
            >
              <template #price="{item}">
                <td>
                  <template v-if="item.is_subscription">
                    <span v-if="item.monthly_price > 0">{{item.monthly_price|currency(item.currency)}} / mese</span>
                    <br><span v-if="item.yearly_price > 0">{{item.yearly_price|currency(item.currency)}} / anno</span>
                  </template>
                  <template v-else>
                    {{item.price|currency(item.currency)}} / attivazione
                  </template>
                </td>
              </template>
              <template #is_active="{item}">
                <td>
                  <CIcon :name="item.is_active ? 'cipCircleCheck' : 'cipMinus'" :class="item.is_active ? 'text-success' : 'text-secondary'" size="lg" />
                </td>
              </template>
              <template #actions="{item}">
                <td class="text-right">
                  <CButton size="sm" variant="outline" color="primary" class="mr-2"
                           v-if="hasPerm('admin.base_plan.update')"
                           @click="$router.push({name: 'base_plan.edit', params: {region: regionId, category: categoryId, id: item.id}})"
                           v-translate translate-context="list.actions"
                  >
                    Edit
                  </CButton>
                  <CButton @click="onDelete(item.id)" size="sm" variant="outline" color="danger"
                           v-if="hasPerm('admin.base_plan.delete')"
                           v-translate translate-context="list.actions"
                  >
                    Delete
                  </CButton>
                </td>
              </template>
            </AjaxTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import AjaxTable from "@/domain/core/components/AjaxTable.vue";

export default {
  name: 'ListBasePlan',
  components: {AjaxTable},
  data() {
    return {
      loading: true,
      fields: [
        {key: 'id', label: this.$pgettext('base_plan.list', 'ID'), _style: 'width:100px;'},
        {key: 'name', label: this.$pgettext('base_plan.list', 'Name')},
        {key: 'price', label: this.$pgettext('base_plan.list', 'Price')},
        {key: 'tags', label: this.$pgettext('base_plan.list', 'Tags')},
        {key: 'is_active', label: this.$pgettext('base_plan.list', 'Active'), filter: false},
        {key: 'actions', label: this.$pgettext('base_plan.list', 'Actions'), sorter: false, filter: false}
      ],
    }
  },
  async mounted() {
    this.loading = true
    this.setRegionId(this.$route.params.region)
    this.setCategoryId(this.$route.params.category)
    await this.fetchConfig({type: 'admin'})
    this.loading = false
  },
  computed: {
    ...mapGetters('region', [
      'basePlans',
      'regionId',
      'categoryId'
    ]),
  },
  methods: {
    ...mapActions('region', [
      'fetchBasePlanList',
      'deleteBasePlan',
      'setRegionId',
      'setCategoryId',
      'fetchCategory',
    ]),
    ...mapActions('login', [
      'fetchConfig'
    ]),
    onDelete(id) {
      this.confirm({
        title: 'Are your sure?',
        message: 'This action is irreversible',
        cb_confirm: async () => {
          await this.deleteBasePlan(id)
        }
      })
    }
  }
}
</script>